/* global exports */
"use strict";

exports.getAttr = function (attr) {
  return function (ob) {
    return function () {
      return ob.attr(attr);
    };
  };
};

exports.postImpl = function (errback) {
  return function (callback) {
    return function (url) {
      return function (data) {
        return function () {
          // Effect
          $.post(url, data, "json").then(
            function (results) {
              callback(results)();
            },
            function (err) {
              errback(err)();
            }
          );
        };
      };
    };
  };
};

exports.parents = function (selector) {
  return function (ob) {
    return function () {
      return ob.parents(selector);
    };
  };
};

exports.length = function (ob) {
  return ob.length;
};

// toArray :: JQuery -> Array Node
exports.toArray = function (jq) {
  return jq.toArray();
};

exports.trigger = function (eventType) {
  return function (eventParams) {
    return function ($element) {
      return function () {
        $element.trigger(eventType, eventParams);
      };
    };
  };
};

exports.getDocument = function () {
  return $(document);
};

exports.getData = function (attr) {
  return function (ob) {
    return function () {
      return ob.data(attr);
    };
  };
};

// setData :: String -> Foreign -> JQuery -> Effect Unit
exports.setData = function (attr) {
  return function (value) {
    return function (ob) {
      return function () {
        ob.data(attr, value);
      };
    };
  };
};

exports.addBack = function (ob) {
  return function () {
    return ob.addBack();
  };
};

exports.filter = function (selector) {
  return function (ob) {
    return function () {
      return ob.filter(selector);
    };
  };
};

exports.one = function (evt) {
  return function (act) {
    return function (ob) {
      return function () {
        ob.one(evt, function (e) {
          act(e)(jQuery(this))();
        });
      };
    };
  };
};

// logErrorOnElement :: String -> JQuery -> Effect Unit
exports.logErrorOnElement = function (msg) {
  return function (jqObj) {
    return function () {
      console.error(msg, jqObj);
    };
  };
};

// wrapNode :: Node -> JQuery
exports.wrapNode = function (node) {
  return jQuery(node);
};

// removeAttr :: String -> JQuery -> Effect Unit
exports.removeAttr = function (attr) {
  return function (jqObj) {
    return function () {
      jqObj.removeAttr(attr);
    };
  };
};

exports.empty = function (jqObj) {
  return function () {
    jqObj.empty();
  };
};

// selector :: JQuery -> String
exports.selector = function (jqObj) {
  return jqObj.selector || "";
};

exports.addTestLoadedMarker = function (markerName) {
  return function () {
    jQuery(
      '<div data-testid="' +
        markerName +
        '" style="position: absolute; top: 0; left: 0; width: 1px; height: 1px;">'
    ).appendTo(document.body);
  };
};

exports.focus = function (jqObj) {
  return function () {
    jqObj.focus();
  };
};
